import store from '@/store'
import { computed } from 'vue'
import { find, get } from 'lodash'

export const useShop = () => {
  const shopData = computed(() => get(store.state, 'shop.shop'))
  const shopId = computed(() => store.getters.shop)
  const shopName = computed(() => store.getters.shopName)
  const shopAddress = computed(() => store.getters.shopAddress)
  const shopPhone = computed(() => store.getters.shopPhone)
  const shopEmail = computed(() => store.getters.shopEmail)
  const shopIndustry = computed(() => get(store.state, 'shop.shopConfig.industry'))
  const shopPointList = computed(() => get(store.state, 'shop.shopSetting.shopPoints'))
  const shopMemberLevelConfig = computed(() => get(store.state, 'shop.shopSetting.memberLevelConfig', []))
  const shopConfig = computed(() => get(store.state, 'shop.shopConfig'))
  const isHeadquarter = computed(() => !!get(shopConfig.value, 'isHeadquarter'))
  const defaultShopPoint = computed(() => find(shopPointList.value, { isDefault: true }))
  const shopTimezone = computed(() => get(store.state, 'shop.shopConfig.timezone'))

  const refreshShop = async (shopId) => {
    // call action to fetch shop by id which returns the shop config/object
    const res = await store.dispatch('shop/findShop', { shopId })
    // if the action returned the shop, commit it to state.SHOP for consumers
    if (res) {
      store.commit('shop/SET_SHOP', res)
    }
  }

  return {
    shopId,
    shopData,
    shopName,
    shopConfig,
    isHeadquarter,
    shopAddress,
    shopPhone,
    shopEmail,
    shopIndustry,
    shopPointList,
    shopMemberLevelConfig,
    defaultShopPoint,
    shopTimezone,
    refreshShop,
  }
}
